<div class="container">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="d-flex popup-head align-items-center">
          <div class="popup-title mr-auto" translate>lblAddCategory</div>
          <div class="float-right">
            <a class="close mr-3" (click)="OnClose()" translate>
              <span class="" aria-hidden="true">&times;</span>
            </a>
          </div>
  
        </div>
        <form [formGroup]="addCategoryForm" (ngSubmit)="addCategorys()">
          <div class="scrollbar">
            <div class="card-content">
              <div class="card-body p-0">
                <div class="row">
                  <div class="w-100 px-0" *ngIf="t.controls">
                    <div class="col-md-6" *ngFor="let ticket of t.controls; let i = index">
                      <div [formGroup]="ticket" class="">
                        <div class="af-form-group">
                          <label for="categoryName" translate>lblCategoryName<span> in
                              {{allLanguage[i].value}}</span>
                            <strong class="mlt6 required"> * </strong> </label>
                          <div class='lbl-info'>
                            <input formControlName="name" class="form-control mb-2" required maxlength="50"
                              [ngClass]="{'is-invalid': cpf.categoryName.invalid && cpf.categoryName.touched}">
                            <div *ngIf="cpf.categoryName.touched && (cpf.categoryName.errors?.required)"
                              class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                                aria-hidden="true"></em>
                                lblCategoryNameRequired
                            </div>
                          </div>
                        </div>
                        <div class="af-form-group" style="display: none;">
                          <label for="languageId" translate>lblLanguageId</label>
                          <div class="lbl-info">
                            <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                              required maxlength="30">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-100 px-0" *ngIf="c.controls">
                    <div class="col-md-6" *ngFor="let ticket of c.controls; let i = index">
                      <div [formGroup]="ticket" class="">
                        <div class="af-form-group">
                          <label for="categoryDescription" translate>lblCategoryDescription<span> in
                              {{allLanguage[i].value}}</span>
                            <strong class="mlt6 required"> * </strong> </label>
                          <div class='lbl-info'>
                            <input formControlName="description" class="form-control mb-2" required maxlength="200"
                              [ngClass]="{'is-invalid': cpf.categoryDescription.invalid && cpf.categoryDescription.touched}">
                            <div *ngIf="cpf.categoryDescription.touched && (cpf.categoryDescription.errors?.required)"
                              class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                                aria-hidden="true"></em>
                                lblCategoryDescriptionFieldRequired
                            </div>
                          </div>
                        </div>
                        <div class="af-form-group" style="display: none;">
                          <label for="languageId" translate>lblLanguageId</label>
                          <div class="lbl-info">
                            <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                              required maxlength="30">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 af-form-group">
                    <label for="template-edit-image" translate>&nbsp; </label>
                    <div class="lbl-info">
                      <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                        <label class="custom-control-label" for="isActive" translate>lblActive</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-3 bg-light pp-footer-top-brdr">
            <div class="d-flex flex-sm-row flex-column justify-content-end">
              <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
                [disabled]="!addCategoryForm.valid" translate><em
                  class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
              <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em
                  class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
